import { rootApi } from '../rootApi';

export const userFavoritesApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyFavorites: builder.query({
            query: () => ({
                url: 'v1/UserFavorites/GetMyFavorites',
                method: 'GET'
            }),
            // ResponseInfo<List<UserFavoriteMenuDto>> → data dizisini ayıkla
            transformResponse: (res) => res?.data ?? res ?? [],
            providesTags: ['UserFavorite']
        }),
        addFavorite: builder.mutation({
            query: (body) => ({
                url: 'v1/UserFavorites/Add',
                method: 'POST',
                body // { menuKey, title, translationKey, link, icon }
            }),
            invalidatesTags: ['UserFavorite']
        }),
        deleteFavorite: builder.mutation({
            query: (id) => ({
                url: `v1/UserFavorites/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['UserFavorite']
        }),
        reorderFavorites: builder.mutation({
            query: (orderedFavoriteIds) => ({
                url: 'v1/UserFavorites/Reorder',
                method: 'POST',
                body: { orderedFavoriteIds }
            }),
            invalidatesTags: ['UserFavorite']
        })
    })
});

export const { useGetMyFavoritesQuery, useLazyGetMyFavoritesQuery, useAddFavoriteMutation, useDeleteFavoriteMutation, useReorderFavoritesMutation } = userFavoritesApi;
